import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { HomeMemberResult } from 'src/app/core/model/api-response/cooking-story-model';
import { User } from 'src/app/core/model/user-model';
import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';

@Component({
  selector: 'app-cooking-story-members-members',
  templateUrl: './cooking-story-members-members.component.html',
  styleUrls: ['./cooking-story-members-members.component.scss'],
})
export class CookingStoryMembersMembersComponent implements OnInit {
  userId: string;
  isOwner: boolean;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public home: HomeMemberResult,
    private bottomSheetRef: MatBottomSheetRef<CookingStoryMembersMembersComponent>,
    private matBottomSheet: MatBottomSheet,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.userDataService.getUser().then((user) => {
      this.userId = user._id;
      if (this.home.owner._id == this.userId) {
        this.isOwner = true;
      }
    });
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  isMe(id: string) {
    if (id == this.userId) return true;

    return false;
  }
  getProfile(user: User) {
    if (user.avatar != '' && user.avatar) return user.avatar;
    if (user.sex == 'male') return 'assets/cookingbook/men.svg';
    return 'assets/cookingbook/women.svg';
  }
}
